import React from "react";
import { Ship } from "lucide-react";
import { useCruise } from "../context/CruiseContext";

const MobileBookCTA = () => {
  const { EVENT } = useCruise();
  return (
    <a
      href={EVENT.bookingUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="mobile-book-cta"
      className="lg:hidden fixed bottom-0 left-0 w-full z-[65] flex items-center justify-start gap-2 pl-5 pr-24 h-14 bg-[#E50914] text-white font-cond font-bold uppercase tracking-widest text-sm border-t-2 border-[var(--hh-gold)] shadow-[0_-4px_20px_rgba(0,0,0,0.5)] active:opacity-90"
    >
      <Ship size={18} />
      Book Your Cabin
    </a>
  );
};

export default MobileBookCTA;
